export class AddToProjectModel {
  saleId: string;
  projectId: string;
  description: string;
}

export class AddToProjectMutationInput {
  saleId: string;
  projectId: string | null;
}
